<div class="flex flex-col items-center gap-4 p-6 box-border w-full max-h-[90vh] overflow-y-auto" [class]="direction">

  <!-- <h2 class="m-0 text-[2rem] text-center">{{titleText}}</h2> -->
  <p class="m-0 px-6 text-xl text-center whitespace-pre-line">{{descriptionText}}</p>

  <div class="w-full min-h-[15rem] rounded-lg overflow-hidden shadow-md shrink-0">
    @if (isEmbedVideo) {
      <iframe
        [src]="safeVideoUrl"
        class="w-full h-full border-0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen>
      </iframe>
    } @else {
      <video
        class="w-full h-full object-contain"
        controls>
        <source [src]="data.videoUrl" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    }
  </div>
  <p class="m-0 px-6 text-base font-normal text-center">{{descriptionText2}}</p>
  <div class="flex flex-col w-full gap-3 mt-2">
    <!-- <mot-button [text]="moreInfoText"
      buttonClass="!bg-primary !text-white !w-full !rounded-lg !align-middle !h-[3rem] !text-lg !font-semibold"
      (onClick)="openMoreInfo()" /> -->

    <mot-button [text]="closeButtonText"
      buttonClass="!border !border-solid !border-[#B4BFCB] !bg-white !text-black !w-full !rounded-lg !align-middle !h-[3rem] !text-lg !font-semibold"
      (onClick)="close()" />

    <button
      class="text-sm text-[#6B7280] underline bg-transparent border-none cursor-pointer mx-auto p-1"
      (click)="closeAndDontShowAgain()">
      {{dontShowAgainText}}
    </button>
  </div>
</div>
